import {LocaleLoader} from './initApp';
import {devLog} from './App/helpers/dev';

export const loadLocale: LocaleLoader = async (locale: string) => {
  // There is no need to load strings for en-US since it's the default.
  // Doing so makes it hard to see changes in development.
  if (locale === 'en-US') {
    return {};
  }

  try {
    const allLocales = await import(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../intl/dist/*'
    );

    const localeImport = allLocales[`${locale}.js`];

    if (localeImport) {
      const {messages} = await localeImport();
      return messages;
    }
  } catch (e) {
    devLog('Error loading locale', e);
  }

  return {};
};
